import { Component, Input, Output, EventEmitter } from '@angular/core';

import { CustomClaimDto } from './../../models/custom-claim-dto';
import { ClaimSelectedDto } from '../../../../../core/api/models/claim-selected-dto';
import { EventTypes } from 'src/app/core/constants/event-types';
import { LoggerService } from 'src/app/core/services/logger.service';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-panel-claims',
    templateUrl: './panel-claims.component.html',
    styleUrls: ['./panel-claims.component.scss'],
    imports: [BaseIndexModule, FormsModule, ReactiveFormsModule]
})
export class PanelClaimsComponent {

  //#region properties

  @Input() claims: Array<CustomClaimDto> = [];
  @Input() menuTitleSelected: string;
  @Input() mainClaim: number;

  @Output("onChangeStatus") output_changeStatus = new EventEmitter<Array<CustomClaimDto>>();

  claimsSelected: number[] = [];
  isSelectAll: boolean;

  //#endregion

  constructor(private loggerService: LoggerService) { }

  ngDoCheck(): void {
    this.detectIsSelectAll();
  }

  onSelectAll(event) {
    try {
      let checked = event?.target?.checked;

      const checkBoxes = document.querySelectorAll(`app-panel-claims tr.claim-row:not(.d-none) [data-checkbox-id]`);

      checkBoxes?.forEach((checkBox) => {

        if (checked)
          (checkBox as HTMLInputElement).checked = false;
        else
          (checkBox as HTMLInputElement).checked = true;

        (checkBox as HTMLInputElement).click();
      })

      this.onChangeClaimsStatus();
    } catch (error) {
      this.loggerService.logError('app-panel-claims', error, EventTypes.systemManagement)

    }


  }

  detectIsSelectAll() {
    try {
      if (this.claims?.length)
      this.isSelectAll = this.claims?.every((item) => { return item.selected === true })
    else
      this.isSelectAll = false;
    } catch (error) {
      this.loggerService.logError('app-panel-claims', error, EventTypes.systemManagement)

    }

  }

  onChangeClaimsStatus() {
    try {
      const TimeOut = setTimeout(() => {
        this.output_changeStatus.emit(this.claims);
        clearTimeout(TimeOut)
      }, 1);
    } catch (error) {
      this.loggerService.logError('app-panel-claims', error, EventTypes.systemManagement)

    }

  }

  onChangeClaimSelected(claim: ClaimSelectedDto) {
    claim.selected = !claim.selected;
  }

  isVisibleAllClaims(): boolean {
    try {
      return this.claims.some(claim => claim.isVisible);

    } catch (error) {
      this.loggerService.logError('app-panel-claims', error, EventTypes.systemManagement)

    }
  }

}
